import {APIService} from '@/services/api.service';

export async function trackBtnClick(userId: string, url: string): Promise<void> {
  try {
    await APIService.post(
      `tracking/click`,
      {},
      {
        params: {
          url,
          user_id: userId,
          mode: process.env.VUE_APP_MODE,
        },
      },
      true,
    );
  } catch (e) {}
}

export async function trackDetailsView(userId: string, category: string, poiId: string, problemId = ''): Promise<void> {
  try {
    await APIService.post(
      `tracking/detail-view`,
      {},
      {
        params: {
          category,
          poi_id: poiId,
          problem_id: problemId,
          user_id: userId,
          mode: process.env.VUE_APP_MODE,
        },
      },
      true,
    );
  } catch (e) {}
}

export async function trackMapsView(userId: string, problemId = ''): Promise<void> {
  try {
    await APIService.post(
      `tracking/map-view`,
      {},
      {
        params: {
          problem_id: problemId,
          user_id: userId,
          mode: process.env.VUE_APP_MODE,
        },
      },
      true,
    );
  } catch (e) {}
}
